import { useScrollAnimation, useStaggerAnimation } from '../../../hooks/useScrollAnimation';

export function Services() {
  const { ref: titleRef, isVisible: titleVisible } = useScrollAnimation();
  const { containerRef, getItemStyle } = useStaggerAnimation(4);

  const scrollToContact = () => {
    const element = document.getElementById('contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const services = [
    {
      icon: 'ri-computer-line',
      title: 'Soporte Técnico Integral',
      items: [
        'Reparación y Mant. de PCs y Notebooks',
        'Asistencia Remota Inmediata',
        'Optimización de Equipos',
        'Soporte a Usuarios',
      ],
      benefits: ['Menos interrupciones', 'Más productividad'],
    },
    {
      icon: 'ri-wifi-line',
      title: 'Redes Estables y Seguras',
      items: [
        'Instalación WiFi Empresarial',
        'Redes LAN para Oficinas',
        'Configuración de Routers y Switch',
        'Cableado Profesional',
      ],
      benefits: ['Conectividad confiable todos los días'],
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Seguridad Informática',
      items: [
        'Firewall Empresarial',
        'Antivirus Corporativo',
        'Backups Automáticos',
        'Recuperación de Datos',
      ],
      benefits: ['Protección real para tu información'],
    },
    {
      icon: 'ri-camera-line',
      title: 'Cámaras y Control',
      items: [
        'CCTV para Comercios y Oficinas',
        'Grabación HD',
        'Control de Accesos',
      ],
      benefits: ['Seguridad y control desde tu celular'],
    },
  ];

  return (
    <section id="servicios" className="py-20 bg-gray-950 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(0,255,240,0.05),transparent_60%)]"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">

        {/* Header */}
        <div ref={titleRef} className={`text-center mb-16 anim-fade-up ${titleVisible ? 'visible' : ''}`}>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Soluciones IT para <strong className="text-neon-400 text-neon-glow-sm">PyMEs</strong> que Necesitan Resultados
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Nos ocupamos de tu tecnología para que vos te ocupes de tu negocio.<br />
            <span className="text-gray-300 font-medium">Soporte claro, rápido y sin vueltas.</span>
          </p>
          <div className="neon-line max-w-xs mx-auto mt-6 opacity-40"></div>
        </div>

        {/* Cards */}
        <div ref={containerRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <article
              key={index}
              style={getItemStyle(index)}
              className="bg-gray-900/80 rounded-xl p-6 border border-gray-800 hover:border-neon-400/40 transition-all duration-300 hover:shadow-neon group hover-lift hover-glow-card flex flex-col"
            >
              <div className="flex flex-col flex-1 relative z-10">
                <div className="w-12 h-12 flex items-center justify-center bg-neon-400/10 border border-neon-400/20 rounded-lg mb-5 group-hover:bg-neon-400/20 group-hover:shadow-neon-sm transition-all duration-300 group-hover:scale-110">
                  <i className={`${service.icon} text-2xl text-neon-400`}></i>
                </div>
                <h3 className="text-base font-bold text-white mb-4">
                  <strong>{service.title}</strong>
                </h3>
                <ul className="space-y-2 mb-5 flex-1">
                  {service.items.map((item, idx) => (
                    <li key={idx} className="flex items-start gap-2 text-xs text-gray-300">
                      <i className="ri-arrow-right-s-line text-neon-400 mt-0.5 shrink-0"></i>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
                <div className="border-t border-gray-700/60 pt-4 space-y-1.5">
                  {service.benefits.map((benefit, idx) => (
                    <p key={idx} className="flex items-center gap-2 text-xs text-neon-400 font-semibold">
                      <i className="ri-check-double-line text-sm shrink-0"></i>
                      {benefit}
                    </p>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Footer note */}
        <div className="mt-14 text-center">
          <div className="inline-flex flex-col sm:flex-row items-center gap-4 bg-gray-900/70 border border-gray-700 rounded-2xl px-8 py-5">
            <div className="flex items-center gap-2 text-gray-300 text-sm">
              <i className="ri-map-pin-2-line text-neon-400 text-lg"></i>
              <span><strong className="text-white">Atención en Zona Norte y CABA</strong> — Visitas con turno previamente coordinado.</span>
            </div>
            <button
              onClick={scrollToContact}
              className="whitespace-nowrap bg-neon-400 text-gray-950 font-bold text-sm px-6 py-2.5 rounded-full hover:bg-neon-300 transition-all duration-200 cursor-pointer hover:scale-105 shadow-lg shadow-neon-400/30 flex items-center gap-2"
            >
              <i className="ri-calendar-check-line text-base"></i>
              Solicitá una evaluación sin cargo
            </button>
          </div>
        </div>

      </div>
    </section>
  );
}
